import * as React from 'react';
import { IOffsiteCampaign } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import { IValue as ImportedValue, NewOffsiteCampaignProvider } from './NewOffsiteCampaignProvider';
import { ActionTypes, NewOffsiteCampaignReducer } from './NewOffsiteCampaignReducer';

export type IValue = ImportedValue;

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export interface IConfiguredDispatcher {
  id: string;
  ownerId: string;
  dispatcher: string;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  campaign: IOffsiteCampaign;
  stepValid: boolean;
  validSteps: number[];
  success?: boolean;
  createdCampaign?: IOffsiteCampaign;
  error?: boolean;
  errorMessage?: string;
  loadingDispatchersData: boolean;
}

export const defaultContextValues: IState = {
  stepValid: false,
  createdCampaign: {
    state: 'TESTING',
    segments: [],
    suppressTimeWindows: [],
  },
  validSteps: [],
  success: false,
  loadingDispatchersData: false,
  campaign: {
    state: 'TESTING',
    segments: [],
    suppressTimeWindows: [],
  },
};

export const NewOffsiteCampaignStateContext = React.createContext<IState | undefined>(undefined);
export const NewOffsiteCampaignDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useNewOffsiteCampaignState() {
  const context = React.useContext(NewOffsiteCampaignStateContext);
  if (context === undefined) {
    throw new Error('useNewOffsiteCampaignState must be used within a NewOffsiteCampaignProvider');
  }
  return context;
}

function useNewOffsiteCampaignDispatch() {
  const context = React.useContext(NewOffsiteCampaignDispatchContext);
  if (context === undefined) {
    throw new Error('UseNewOffsiteCampaignDispatch must be used within a NewOffsiteCampaignProvider');
  }
  return context;
}

export {
  NewOffsiteCampaignProvider,
  NewOffsiteCampaignReducer,
  useNewOffsiteCampaignState,
  useNewOffsiteCampaignDispatch,
};
